import PriceToPayHeader from './parts/Header'
import PriceItemsList from './parts/PriceItemsList'
import { priceToPayStyles } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/styles'
import { PriceToPayBaseProps } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/types'
import Collapsible from '@/features/ui/components/Collapsible'
import ChevronDownIcon from '@/features/ui/icons/components/ChevronDownIcon'
import { FC, memo, useState } from 'react'
import { Pressable, View } from 'react-native'
import Animated, {
    Easing,
    useAnimatedStyle,
    useDerivedValue,
    withTiming,
} from 'react-native-reanimated'

const PriceToPayCollapsible: FC<PriceToPayBaseProps> = ({
    price,
    items = [],
    headingVariant = 'h3',
}) => {
    const [expanded, setExpanded] = useState(false)

    const rotation = useDerivedValue(() =>
        withTiming(expanded ? 0 : 180, {
            duration: 220,
            easing: Easing.out(Easing.cubic),
        })
    )

    const chevronAnimatedStyle = useAnimatedStyle(() => ({
        transform: [{ rotate: `${rotation.value}deg` }],
    }))

    return (
        <View style={priceToPayStyles.container}>
            <Collapsible open={expanded} containerStyle={priceToPayStyles.itemsContainer}>
                <PriceItemsList items={items} />
            </Collapsible>
            <Pressable
                onPress={() => setExpanded((prev) => !prev)}
                style={priceToPayStyles.headerContainer}
            >
                <PriceToPayHeader
                    price={price}
                    headingVariant={headingVariant}
                    TrailingAccessory={
                        <Animated.View style={chevronAnimatedStyle}>
                            <ChevronDownIcon color={priceToPayStyles.chevron.color} />
                        </Animated.View>
                    }
                />
            </Pressable>
            <View style={priceToPayStyles.divider} />
        </View>
    )
}

export default memo(PriceToPayCollapsible)
